import { DateTime } from "luxon";

export enum EmployeeAssistanceProgramProvision {
    CORE = 'CORE',
    FACE_TO_FACE_1_3_VISITS = 'FACE_TO_FACE_1_3_VISITS',
    FACE_TO_FACE_1_5_VISITS = 'FACE_TO_FACE_1_5_VISITS',
    FACE_TO_FACE_1_6_VISITS = 'FACE_TO_FACE_1_6_VISITS',
    FACE_TO_FACE_1_8_VISITS = 'FACE_TO_FACE_1_8_VISITS',
    NOT_INCLUDED = 'NOT_INCLUDED',
}

const premierVisits = [EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_3_VISITS, EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_5_VISITS,
    EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_6_VISITS, EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_8_VISITS];

export namespace EmployeeAssistanceProgramProvision {
    export function findProgramNameFor(employeeAssistanceProgram: EmployeeAssistanceProgramProvision | undefined, currentTime: DateTime) {
        const isCore = EmployeeAssistanceProgramProvision.CORE === employeeAssistanceProgram;
        if(employeeAssistanceProgram === undefined) {
            return '';
        }
        if(is2026OrAfter(currentTime)) {
            if(isCore) {
                return 'PrincipalCore';
            } else if(EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_3_VISITS === employeeAssistanceProgram) {
                return 'PrincipalPremier3';
            } else if(EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_5_VISITS === employeeAssistanceProgram) {
                return 'PrincipalPremier5';
            } else if(EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_6_VISITS === employeeAssistanceProgram) {
                return 'PrincipalPremier6';
            } else if(EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_8_VISITS === employeeAssistanceProgram) {
                return 'PrincipalPremier8';
            }
        }
        if(isCore) {
            return 'Principal Core';
        } else if(premierVisits.includes(employeeAssistanceProgram)) {
            return 'your organization\'s name'
        }
        return '';
    }

    export function findPhoneNumberFor(employeeAssistanceProgram: EmployeeAssistanceProgramProvision | undefined, currentTime: DateTime) {
        const isCore = EmployeeAssistanceProgramProvision.CORE === employeeAssistanceProgram;
        if(employeeAssistanceProgram === undefined) {
            return '';
        }
        if(is2026OrAfter(currentTime)) {
            if(isCore) {
                return '844-869-2365';
            } else if(premierVisits.includes(employeeAssistanceProgram)) {
                return '833-955-3389'
            }
        }
        if(isCore) {
            return '800-450-1327';
        } else if(premierVisits.includes(employeeAssistanceProgram)) {
            return '800-356-7089'
        }
        return '';
    }

    export function findEmployeeAssistanceProgramFormNumberFor(employeeAssistanceProgram: EmployeeAssistanceProgramProvision | undefined, currentTime: DateTime) {
        const isCore = EmployeeAssistanceProgramProvision.CORE === employeeAssistanceProgram;
        if(is2026OrAfter(currentTime)) {
            if(isCore) {
                return 'GP63470';
            } else if(EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_3_VISITS === employeeAssistanceProgram) {
                return 'GP63469E3'
            } else if(EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_5_VISITS === employeeAssistanceProgram) {
                return 'GP63469E5'
            } else if(EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_6_VISITS === employeeAssistanceProgram) {
                return 'GP63469E6'
            } else if(EmployeeAssistanceProgramProvision.FACE_TO_FACE_1_8_VISITS === employeeAssistanceProgram) {
                return 'GP63469E8'
            }
        } else if(isCore) {
            return 'GP59489';
        }
        return '';
    }

    export function is2026OrAfter(currentTime: DateTime) {
        const date = process.env.REACT_APP_ENV === 'prod' ? "2026-01-01" : "2025-12-16";
        return currentTime >= DateTime.fromISO(date, { zone: "America/Chicago" }).startOf('day');
    }
}
